module.exports = __webpack_public_path__ + "assets/img/title-469b3f9e.png";